import axios from '@fs/zion-axios'
import { useCallback, useEffect, useRef, useState } from 'react'
import useFetchData from './useFetchData'
import getIdentBaseUrl from '../utils/getIdentBaseUrl'

const fetchProviders = async () => {
  const { data } = await axios.get(`${getIdentBaseUrl()}/service/ident/authn/accounts/CURRENT`)
  return data?.identityProviderIDs ?? []
}

export default function useProviders() {
  const { data: remoteProviders, loading: providersLoading } = useFetchData(fetchProviders, {
    initialData: [],
  })
  const buttonRefs = useRef({})
  const [localProviders, setLocalProviders] = useState(null)
  const [providerToFocus, setProviderToFocus] = useState(null)
  const providers = localProviders ?? remoteProviders

  const handleRemoveProvider = useCallback(
    (providerName) => {
      const newProviders = providers.filter((provider) => {
        return provider !== providerName
      })
      setLocalProviders(newProviders)
      setProviderToFocus(providerName)
    },
    [providers]
  )

  const handleAddProvider = useCallback(
    (providerName) => {
      const newProviders = [...providers, providerName]
      setLocalProviders(newProviders)
      setProviderToFocus(providerName)
    },
    [providers]
  )

  useEffect(() => {
    if (providerToFocus) {
      setProviderToFocus(null)
      setTimeout(() => {
        buttonRefs.current[providerToFocus]?.focus()
      }, 100)
    }
  }, [providerToFocus])

  return { buttonRefs, providers, providersLoading, handleAddProvider, handleRemoveProvider }
}
